import { FunctionComponent, useState } from "react"
import { Button, Table } from "react-bootstrap"
import { Pass, RolePass } from "../data/models.interface"
import { sortArray } from "../utils/ArrayUtils"
import RolePassModal from "./RolePassModal"
import { formatDate } from "../utils/AccessControlFormatter"

interface IRolePassesSubForm {
	rolePasses: RolePass[]
	setRolePasses: (value: RolePass[]) => any
	passes: Pass[]
}
const RolePassesSubForm: FunctionComponent<IRolePassesSubForm> = ({
	rolePasses: value,
	setRolePasses: setValue,
	passes,
}) => {
	// this is which row is open in the modal; undefined means the modal is closed
	const [modalIndex, setModalIndex] = useState<number | null>(null)
	// sorting will call setValue with the items in a new order
	const sortBy = (sortProperty: string) => setValue(sortArray(value, sortProperty, "AUTO"))
	//
	return (
		<>
			<RolePassModal
				onHide={() => setModalIndex(null)}
				rolePasses={value}
				setRolePasses={setValue}
				index={modalIndex}
				passes={passes}
			/>
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => sortBy("passName")}>Pass</th>
						<th onClick={() => sortBy("startDate")}>Start Date</th>
						<th onClick={() => sortBy("endDate")}>End Date</th>
					</tr>
				</thead>
				<tbody>
					{value?.map((rolePass, i) => (
						<tr key={rolePass.passId} onClick={() => setModalIndex(i)}>
							<td>{rolePass.passName || rolePass.passId}</td>
							<td>{formatDate(rolePass.startDate)}</td>
							<td>{formatDate(rolePass.endDate)}</td>
						</tr>
					))}
					<tr>
						<td colSpan={10} className="text-center">
							<Button variant="outline-success" size="sm" onClick={() => setModalIndex(value?.length || 0)}>
								Add Pass
							</Button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	)
}
export default RolePassesSubForm
